import { NgModule, Optional, SkipSelf } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AccountSettingsEffects } from './account-settings.effects';
import { IAccountSettingsFeature } from './account-settings.feature.state';
import { AccountSettingsReducer } from './account-settings.reducer';
import { nameof } from '@symphony-solo/shared/utils/src';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<IAccountSettingsFeature>('AccountSettingsFeature'), AccountSettingsReducer),
    EffectsModule.forFeature([AccountSettingsEffects]),
  ],
})
export class AccountSettingsStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: AccountSettingsStateModule
  ) {
    if (parentModule) {
      throw new Error('AccountSettingsStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
